import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.Filters;
const filterDisplay = CONST.globalProject.FilterDisplay;

// initial state
// object name must match specification name
//specification, label, defaultValue, collapsible, expandDefault, groupType, subgroup, className
const filters = {
    Type: new FormControl.FilterGroup('Type', 'News Types', null, false, true, 'checkbox', undefined, '', 'group-types', filterDisplay.hideType || 'False'),
    Topic: new FormControl.FilterGroup('Topic', 'News Topics', null, false, true, 'checkbox', undefined, '',  'group-topics', filterDisplay.hideTopic || 'False'),
    Sort: new FormControl.FilterGroup('Sort', 'Sort by', 'Sort By', false, true, 'select', undefined, '', 'group-sort', filterDisplay.hideSort || 'False'),
    searchTerm: new FormControl.FilterGroup(
        'Query', 'Search', '', false, true, 'textbox',
        new FormControl.Textbox('Search', 'Query', true), 'filter-search', 'group-search'
    ),
};


FormControl.assignFilters(filterObj, filters);

filters.Type.subgroup.unshift(new FormControl.SelectOption('999', 'All News Types', true, false, false));
filters.Topic.subgroup.unshift(new FormControl.SelectOption('999', 'All Topics', true, false, false));

export { filters as default };